// extracted by css-extract-rspack-plugin
export default {"textarea":"product-listing-fragment__Textarea_textarea__rVUXu"};